console.log('operator');

// ______________________________________
// フィロソフィー部分固定スクロール
(() => {
    const wrap = document.querySelector('.philosophyWrap');
    const slides = Array.from(document.querySelectorAll('.philosophySlide'));
    if (!wrap || slides.length < 2) return;

    const mq = window.matchMedia('(min-width: 769px)'); // ここはSP境界に合わせて変更

    const HOLD_VH = 100;
    const GAP_VH = 50;
    const step = HOLD_VH + GAP_VH;

    let index = 0;
    let isAnimating = false;
    let pendingIndex = null;
    let isEnabled = false;
    let ticking = false;

    function setPcView() {
        slides.forEach((s, i) => {
            s.classList.toggle('is-active', i === 0);
        });
        index = 0;
        isAnimating = false;
        pendingIndex = null;
    }

    function setSpView() {
        slides.forEach(s => s.classList.remove('is-active'));
        index = 0;
        isAnimating = false;
        pendingIndex = null;
    }

    function getPassedVh() {
        const rect = wrap.getBoundingClientRect();
        const vh = window.innerHeight;
        const passedPx = Math.max(0, -rect.top);
        return (passedPx / vh) * 100;
    }

    function calcDesiredIndex(passedVh) {
        const n = slides.length;
        let desired = 0;

        for (let k = 0; k < n - 1; k++) {
            const trigger = HOLD_VH + k * step;
            if (passedVh >= trigger) desired = k + 1;
        }

        return Math.min(desired, n - 1);
    }

    function goTo(nextIndex) {
        if (!isEnabled) return;
        if (nextIndex === index) return;

        if (Math.abs(nextIndex - index) > 1) {
            slides[index].classList.remove('is-active');
            index = nextIndex;
            slides[index].classList.add('is-active');
            return;
        }

        isAnimating = true;

        slides[index].classList.remove('is-active');
        index = nextIndex;
        slides[index].classList.add('is-active');

        const currentSlide = slides[index];

        function handler(e) {
            if (e.propertyName !== 'opacity') return;
            currentSlide.removeEventListener('transitionend', handler);
            isAnimating = false;

            if (pendingIndex !== null && pendingIndex !== index) {
                const p = pendingIndex;
                pendingIndex = null;
                goTo(p);
            } else {
                pendingIndex = null;
            }
        }

        currentSlide.addEventListener('transitionend', handler);
    }

    function update() {
        if (!isEnabled) return;

        const passedVh = getPassedVh();
        const desired = calcDesiredIndex(passedVh);

        if (isAnimating) {
            pendingIndex = desired;
            return;
        }

        if (desired !== index) {
            goTo(desired);
        }
    }

    function onScroll() {
        if (!isEnabled) return;

        if (!ticking) {
            ticking = true;
            requestAnimationFrame(() => {
                ticking = false;
                update();
            });
        }
    }

    function handleModeChange() {
        if (mq.matches) {
            isEnabled = true;
            setPcView();
            update();
        } else {
            isEnabled = false;
            setSpView();
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', handleModeChange);

    if (mq.addEventListener) {
        mq.addEventListener('change', handleModeChange);
    } else {
        mq.addListener(handleModeChange);
    }

    handleModeChange();
})();

// ______________________________________
// スライダー
document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector(".bnr_marquee");
    if (!root) return;

    const viewport = root.querySelector(".bnr_viewport");
    const track = root.querySelector(".bnr_track");
    const dotsWrap = root.querySelector(".bnr_dots");

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const speed = parseFloat(root.dataset.speed || "0.5");

    const originalSlides = Array.from(track.children);
    const originalCount = originalSlides.length;

    // 無限ループ用に複製
    originalSlides.forEach((li) => {
        track.appendChild(li.cloneNode(true));
    });

    // ドット生成
    const dots = [];
    for (let i = 0; i < originalCount; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", `slide ${i + 1}`);
        b.addEventListener("click", () => jumpTo(i));
        dotsWrap.appendChild(b);
        dots.push(b);
    }

    let cycleWidth = 0;
    let slideCenters = [];
    let rafId = null;
    let lastActive = -1;

    // ドラッグ用
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;

    const normalizeScroll = () => {
        if (!cycleWidth) return;

        while (viewport.scrollLeft >= cycleWidth) {
            viewport.scrollLeft -= cycleWidth;
        }
        while (viewport.scrollLeft < 0) {
            viewport.scrollLeft += cycleWidth;
        }
    };

    const recalc = () => {
        const slides = Array.from(track.children).slice(0, originalCount);

        const trackLeft = track.getBoundingClientRect().left;
        const lefts = slides.map((el) => el.getBoundingClientRect().left - trackLeft);
        const widths = slides.map((el) => el.getBoundingClientRect().width);

        const lastIdx = slides.length - 1;
        cycleWidth = lefts[lastIdx] + widths[lastIdx];
        slideCenters = slides.map((_, i) => lefts[i] + widths[i] / 2);

        normalizeScroll();
    };

    const setActiveDot = (idx) => {
        if (idx === lastActive) return;
        dots.forEach((d) => d.classList.remove("is-active"));
        if (dots[idx]) dots[idx].classList.add("is-active");
        lastActive = idx;
    };

    const getActiveIndex = () => {
        if (!cycleWidth || slideCenters.length === 0) return 0;

        const x = (viewport.scrollLeft % cycleWidth) + viewport.clientWidth / 2;

        let best = 0;
        let bestDist = Infinity;

        for (let i = 0; i < slideCenters.length; i++) {
            const dist = Math.abs(slideCenters[i] - x);
            if (dist < bestDist) {
                bestDist = dist;
                best = i;
            }
        }
        return best;
    };

    const tick = () => {
        if (!isDragging) {
            viewport.scrollLeft += speed;
            normalizeScroll();
            setActiveDot(getActiveIndex());
        }

        rafId = requestAnimationFrame(tick);
    };

    const jumpTo = (index) => {
        const current = viewport.scrollLeft % cycleWidth;
        const targetCenter = slideCenters[index];
        const targetScroll = targetCenter - viewport.clientWidth / 2;

        viewport.scrollLeft = (viewport.scrollLeft - current) + targetScroll;
        normalizeScroll();
        setActiveDot(index);
    };

    const getPageX = (e) => {
        if (e.touches && e.touches.length) return e.touches[0].pageX;
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].pageX;
        return e.pageX;
    };

    const dragStart = (e) => {
        isDragging = true;
        moved = false;
        startX = getPageX(e);
        startScrollLeft = viewport.scrollLeft;

        viewport.classList.add("is-dragging");
    };

    const dragMove = (e) => {
        if (!isDragging) return;

        const x = getPageX(e);
        const diff = x - startX;

        if (Math.abs(diff) > 3) moved = true;

        // 指を右へ動かすとスライダーは左へ戻るのでマイナス
        viewport.scrollLeft = startScrollLeft - diff;
        normalizeScroll();
        setActiveDot(getActiveIndex());

        // 横スワイプ中にページ全体が動きにくいように
        if (e.cancelable) e.preventDefault();
    };

    const dragEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove("is-dragging");
        normalizeScroll();
        setActiveDot(getActiveIndex());
    };

    // マウス
    viewport.addEventListener("mousedown", dragStart);
    window.addEventListener("mousemove", dragMove);
    window.addEventListener("mouseup", dragEnd);
    viewport.addEventListener("mouseleave", dragEnd);

    // タッチ
    viewport.addEventListener("touchstart", dragStart, { passive: true });
    viewport.addEventListener("touchmove", dragMove, { passive: false });
    viewport.addEventListener("touchend", dragEnd);
    viewport.addEventListener("touchcancel", dragEnd);

    // 画像のドラッグ防止
    viewport.querySelectorAll("img").forEach((img) => {
        img.addEventListener("dragstart", (e) => e.preventDefault());
    });

    // クリック誤爆防止
    viewport.addEventListener("click", (e) => {
        if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
        }
    }, true);

    // resize対応
    const ro = new ResizeObserver(() => recalc());
    ro.observe(viewport);
    ro.observe(track);

    recalc();
    setActiveDot(0);
    rafId = requestAnimationFrame(tick);

    document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
        } else {
            if (!rafId) rafId = requestAnimationFrame(tick);
        }
    });
});
// ______________________________________

